import React, { FC } from 'react';
import Lottie from 'lottie-react-web';

import Container from './styles';
import animation from './loader.json';

const Loader: FC = () => {
  return (
    <Container>
      <Lottie
        options={{
          animationData: animation,
          loop: true,
          autoplay: true,
        }}
      />
    </Container>
  );
};

export default Loader;
